import React, { Component } from 'react'
import { Link } from 'gatsby'
import kebabCase from 'lodash/kebabCase'
import * as styles from './tags.module.css'

export default class Tags extends Component {

  render() {
    let tags = this.props.tags
    if (tags.length > 3 && this.props.short === true) {
      tags = tags.slice(0, 3)
    } else {
      tags = tags.slice(0, 7)
    }
    return (
      <div className={styles.tags}>
        {(tags || []).map((tag, index) => (
          <Link to={`/tags/${kebabCase(tag)}/`} key={index}>
            <div className={styles.article_tag} key={index}><span className={styles.taglist_name}>{tag}</span></div>
          </Link>
        ))}
      </div>
    )
  }
}